import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

export function formatDate(dateString) {
  if (!dateString) return '-';
  const isoDateMatch = /^(\d{4})-(\d{2})-(\d{2})/.exec(String(dateString));
  if (isoDateMatch) {
    return `${isoDateMatch[3]}-${isoDateMatch[2]}-${isoDateMatch[1]}`;
  }
  const date = new Date(dateString);
  if (Number.isNaN(date.getTime())) return '-';
  const day = String(date.getDate()).padStart(2, '0');
  const month = String(date.getMonth() + 1).padStart(2, '0');
  return `${day}-${month}-${date.getFullYear()}`;
}

export function formatDateTime(dateString) {
  if (!dateString) return '-';
  const date = new Date(dateString);
  if (Number.isNaN(date.getTime())) return '-';
  const day = String(date.getDate()).padStart(2, '0');
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const hours = String(date.getHours()).padStart(2, '0');
  const minutes = String(date.getMinutes()).padStart(2, '0');
  return `${day}-${month}-${date.getFullYear()} ${hours}:${minutes}`;
}

export function formatCurrency(amount) {
  return new Intl.NumberFormat('en-IN', {
    style: 'currency',
    currency: 'INR',
    minimumFractionDigits: 2
  }).format(amount);
}

export function getStatusColor(status) {
  const colors = {
    'Active': 'bg-green-100 text-green-800',
    'Inactive': 'bg-gray-100 text-gray-800',
    'Present': 'bg-green-100 text-green-800',
    'Absent': 'bg-red-100 text-red-800',
    'Half-day': 'bg-yellow-100 text-yellow-800',
    'Leave': 'bg-blue-100 text-blue-800',
    'Pending': 'bg-yellow-100 text-yellow-800',
    'Approved': 'bg-green-100 text-green-800',
    'Rejected': 'bg-red-100 text-red-800'
  };
  return colors[status] || 'bg-gray-100 text-gray-800';
}
export function filterAttendanceRequests(rows, employees, filters) {
  const { month, year, fromDate, toDate, department, employeeIds } = filters;
  const byId = new Map(employees.map(employee => [String(employee.employee_id), employee]));
  const monthPrefix = `${year}-${String(month).padStart(2, '0')}`;
  const hasRange = Boolean(fromDate || toDate);
  if (hasRange && (!fromDate || !toDate || fromDate > toDate)) return [];
  return rows.filter(row => {
    const id = String(row.employee_id);
    const day = String(row.work_date || row.worked_date || row.date || '').slice(0, 10);
    return Boolean(day) &&
      (hasRange ? day >= fromDate && day <= toDate : day.slice(0, 7) === monthPrefix) &&
      (department === 'all' || byId.get(id)?.department === department) &&
      (!employeeIds.length || employeeIds.map(String).includes(id));
  });
}

